"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.includes");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _field = _interopRequireDefault(require("../field"));

var _formElements = require("@evidation/form-elements");

var _rangeLabel = _interopRequireDefault(require("./labels/rangeLabel"));

var _react = _interopRequireDefault(require("react"));

var _responsiveTable = require("./responsiveTable");

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StyledTd = (0, _styledComponents["default"])(_responsiveTable.Td).withConfig({
  displayName: "renderTabularRow__StyledTd",
  componentId: "uzrji1-0"
})(["vertical-align:top;padding:0 3px;", " .radiocheckboxlabelholder{display:flex;justify-content:center;margin-top:", ";}@media only screen and (max-width:760px){.radiocheckboxlabelholder{display:block;}}"], function (props) {
  return props.component === "radioinput" && "\n        div.radiogroup {\n          margin-top: auto;\n          min-height: 23px;\n        }\n        ";
}, function (props) {
  return props.component === "checkbox" ? "-12px !important" : "inherit";
}); //
// Render Tabular Row
//

var _default = function _default(_ref) {
  var fields = _ref.fields,
      meta = _ref.meta,
      config = _ref.config,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["fields", "meta", "config"]);
  return fields.map(function (_ref2, index) {
    var name = _ref2.name,
        item = (0, _objectWithoutProperties2["default"])(_ref2, ["name"]);
    // TODO Awkward key generation here since the key needs to be different based on Tabular vs Tabular List
    var key = config.component === "tabular" ? "".concat(config.key, ".").concat(_lodash["default"].snakeCase(fields[0].name || fields[0].label), ".").concat(_lodash["default"].snakeCase(name || item.label)) : "".concat(rest.name, ".").concat(_lodash["default"].snakeCase(name || item.label)); // checking for item.label !undefined !null !empty
    // fixes issue where labels would appear as `undefined`

    var TabularLabel = item.label ? /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
      label: "".concat(item.label),
      labelStyle: item.labelStyle
    }) : "";
    var displayLabel = index === 0 && !_lodash["default"].includes(["tabularlist"], config.component);

    var displayRow = _lodash["default"].includes(["range_0to5", "range_0to10", "range_1to10", "radioinput"], item.component);

    if (item.component === 'checkbox') {
      displayLabel = true;
      item.label = ' ';
    }

    var field = /*#__PURE__*/_react["default"].createElement(_field["default"], (0, _extends2["default"])({
      "interface": item.component
    }, item, rest, {
      config: _objectSpread(_objectSpread({}, item.config), {}, {
        displayLabel: displayLabel,
        displayRow: displayRow,
        split: true
      }),
      key: key,
      name: key
    }));

    var content = item.component === "radioinput" && (!_lodash["default"].isEmpty(rest.min_label) || !_lodash["default"].isEmpty(rest.max_label)) ? /*#__PURE__*/_react["default"].createElement(_rangeLabel["default"], {
      min_label: rest.min_label,
      max_label: rest.max_label
    }, field) : field; // TODO add id without dot

    return /*#__PURE__*/_react["default"].createElement(StyledTd, {
      component: item.component,
      label: item.component !== "label" && TabularLabel,
      key: key
    }, content);
  });
};

exports["default"] = _default;